import React from 'react';
import './termsofuse-css.css'

const TermsOfUse = () => (
    <div id="termsOfUse">
        <p>
            Welcome to Viral.net, operated by Viral (Viral, Inc.), located at 105 W 29th St 42L, NY 10001 NY
            ("Viral.net,"
            "we," or "our").
            <br/>
            <br/>
            By using the Viral.net website and mobile website (the “Websites”), as well as the
            Infrastructure-as-a-Service
            (IaaS) platform (collectively, the “Service”), you agree to be bound by these Terms of Use (this “Terms of
            Use”
            or “Agreement”), whether or not you register as a member of Viral.net ("Member"). If you wish to become a
            Member
            and/or make use of the Service, please read this Agreement. If you object to anything in this Agreement or
            the
            Viral.net Privacy Policy, do not use the Service.
            PLEASE READ THIS AGREEMENT CAREFULLY AS IT CONTAINS IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS,
            REMEDIES
            AND OBLIGATIONS, INCLUDING VARIOUS LIMITATIONS AND EXCLUSIONS, AND A DISPUTE RESOLUTION CLAUSE THAT GOVERNS
            HOW
            DISPUTES WILL BE RESOLVED.
            <br/>
            <br/>
            1. Electronic Agreement. This Terms of Use is an electronic contract that sets out the legally binding terms
            of
            your use of the Service. This Terms of Use is subject to change by Viral.net at any time, effective upon
            posting
            on the Viral.net website. By accessing and/or using the Service or becoming a Member, you accept this Terms
            of
            Use and agree to the terms, conditions and notices contained or referenced herein. Your continued use of the
            Service following Viral.net’s posting of revised terms of any section of the Terms of Use will constitute
            your
            express and binding acceptance of and consent to the revised Terms of Use.
            <br/>
            <br/>
            2. Access and Retention. In order to access and retain this electronic Agreement, you must have access to
            the
            World Wide Web, either directly or through devices that access web-based content, and pay any service fees
            associated with such access. In addition, you must use all equipment necessary to make such connection to
            the
            World Wide Web, including a computer and modem or other access device. Please print a copy of this document
            for
            your records. To retain an electronic copy of this Agreement, you may save it into any word processing
            program.
            <br/>
            <br/>
            3. Eligibility. You must be at least eighteen (18) years of age. By using the Service, you represent and
            warrant
            that you have the right, authority and capacity to enter into this Agreement and to abide by all of the
            terms
            and conditions of this Agreement.
            The Service is also not available to any users who have been previously removed or suspended from the
            Service.
            By using the Service, you represent and warrant that you have the right, authority and capacity to enter
            into
            this Terms of Use and to abide by all of the terms and conditions of this Terms of Use.
            <br/>
            <br/>
            4. Commercial Use of Service. If you are using and/or accessing the Service on behalf of a company, entity,
            or
            organization (collectively, a “Subscribing Entity”), you represent and warrant that:
            <br/>
            <br/>
            a. You are an authorized representative of the Subscribing Entity, and that you have the authority to bind
            the
            Subscribing Entity to this Terms of Use;
            b. You have read and understand this Terms of Use; and
            c. You agree to this Terms of Use on behalf of the Subscribing Entity.
            <br/>
            <br/>
            Illegal and/or unauthorized uses of the Service include, but are not limited to, collecting usernames and/or
            email addresses of Members by electronic or other means for the purpose of sending unsolicited email,
            unauthorized framing of or linking to the Websites, sharing or disclosing your username or password to any
            third
            party or permitting any third party to access your account, attempting to impersonate another user or
            person,
            use of the Service in any fraudulent or misleading manner, any automated use of the system, such as scraping
            the
            Websites, automated scripts, spiders, robots, crawlers, harvesting or data mining tools or the like,
            interfering
            with, disrupting, or creating an undue burden on the Service or the networks or services connected to the
            Service, and using the Service in a manner inconsistent with any and all applicable laws and regulations.
            Illegal and/or unauthorized use of the Service may be investigated, and appropriate legal action may be
            taken,
            including without limitation, civil, criminal, and injunctive redress. Use of the Service is with the
            permission
            of Viral.net, which may be revoked at any time, for any reason, in Viral.net’s sole discretion.
            <br/>
            <br/>
            5. Account Security. You are responsible for maintaining the confidentiality of the username and password
            that
            you designate during the registration process, and you are fully responsible for all activities that occur
            under
            your username and password. You agree to (a) immediately notify Viral.net of any unauthorized use of your
            username or password or any other breach of security, and (b) ensure that you exit from your account at the
            end
            of each session. Viral.net will not be liable for any loss or damage arising from your failure to comply
            with
            this provision. You should use particular caution when accessing your account from a public or shared
            computer
            so that others are not able to view or record your password or other personal information. If you share your
            computer with others, you may wish to consider disabling your auto-sign in feature if you have it linked to
            your
            Viral.net account.
            <br/>
            <br/>
            6. Your Use of the Service
            <br/>
            <br/>
            a. You must not copy or capture, or attempt to copy or capture, any content from the Websites or Service,
            unless
            given express permission by Viral.net.
            b. You must not copy, republish, adapt, make available or otherwise communicate to the public, display,
            perform,
            transfer, share, distribute or otherwise use or exploit any content on or from the Websites and/or Service.
            c. You must not use any content in any way that is designed to create a separate service or that replicates
            any
            part of the offering of the Service.
            d. You must not employ scraping or similar techniques to aggregate, repurpose, republish or otherwise make
            use
            of any content.
            e. You must not employ any techniques or make use of any services, automated or otherwise, designed to
            misrepresent your activity on the Service, including without limitation by the use of bots, botnets,
            scripts,
            apps, plugins, extensions or other automated means to register accounts, log in, send messages, post
            comments,
            or otherwise to act on your behalf, particularly where such activity occurs in a multiple or repetitive
            fashion.
            You must not offer or promote the availability of any such techniques or services to any other users of the
            Service.
            f. You must not alter or remove, or attempt to alter or remove, any trademark, copyright or other
            proprietary or
            legal notices contained in, or appearing on, the Websites or any Content appearing on the Websites.
            g. You must not, and must not permit any third party to, copy or adapt the object code of the Websites, or
            reverse engineer, reverse assemble, decompile, modify or attempt to discover any source or object code of
            any
            part of the Websites, or circumvent or attempt to circumvent or copy any copy protection mechanism or access
            any
            rights management information pertaining to content on the Websites.
            h. You must not use the Websites to upload, post, store, transmit, display, copy, distribute, promote, make
            available or otherwise communicate to the public:
            i. any content that is offensive, abusive, libelous, defamatory, obscene, racist, sexually explicit,
            ethnically
            or culturally offensive, indecent, that promotes violence, terrorism, or illegal acts, incites hatred on
            grounds
            of race, gender, religion or sexual orientation, or is otherwise objectionable in Viral.net’s sole and
            reasonable discretion;
            ii. any information, content or other material that violates, plagiarizes, misappropriates or infringes the
            rights of third parties including, without limitation, copyright, trademark rights, rights of privacy or
            publicity, confidential information or any other right; or
            iii. any content that violates, breaches or is contrary to any law, rule, regulation, court order or is
            otherwise is illegal or unlawful in Viral.net’s sole and reasonable opinion;
            iv. any material of any kind that contains any virus, Trojan horse, spyware, adware, malware, bot, time
            bomb,
            worm, or other harmful or malicious component, which will or might overburden, impair or disrupt the Service
            or
            servers or networks forming part of, or connected to, the Service, or which does or might restrict or
            inhibit
            any other user's use and enjoyment of the Service; or
            v. any unsolicited or unauthorized advertising, promotional messages, spam or any other form of
            solicitation.
            i. You must not commit or engage in, or encourage, induce, solicit or promote, any conduct that would
            constitute
            a criminal offense, give rise to civil liability or otherwise violate any law or regulation.
            j. You must not rent, sell or lease access to the Service, or any content on the Websites.
            k. You must not deliberately impersonate any person or entity or otherwise misrepresent your affiliation
            with a
            person or entity, for example, by registering an account in the name of another person or company, or
            sending
            messages or making comments using the name of another person.
            l. You must not stalk, exploit, threaten, abuse or otherwise harass another user, or any Viral.net employee.
            If
            Viral.net determines that any user has threatened, stalked, harassed, or verbally abused any Viral.net
            employee
            or another Viral.net Member, Viral.net reserves the right to immediately terminate that user’s membership
            and
            suspend access to the Service. Any user so suspended shall not be entitled to any refund of unused
            subscription
            fees.
            m. You must not sell or transfer, or offer to sell or transfer, any Viral.net account to any third party
            without
            the prior written approval of Viral.net.
            n. You must not collect or attempt to collect personal data, or any other kind of information about other
            users,
            including without limitation, through spidering or any form of scraping.
            o. You must not violate, circumvent or attempt to violate or circumvent any data security measures employed
            by
            Viral.net; access or attempt to access data or materials which are not intended for your use; log into, or
            attempt to log into, a server or account which you are not authorized to access; attempt to scan or test the
            vulnerability of Viral.net’s servers, system or network or attempt to breach Viral.net’s data security or
            authentication procedures; attempt to interfere with the Websites or the Services by any means including,
            without limitation, hacking Viral.net’s servers or systems, submitting a virus, overloading, mail-bombing or
            crashing. Without limitation to any other rights or remedies of Viral.net under these Terms of Use,
            Viral.net
            reserves the right to investigate any situation that appears to involve any of the above, and may report
            such
            matters to, and cooperate with, appropriate law enforcement authorities in prosecuting any users who have
            participated in any such violations.
            <br/>
            <br/>
            You agree to comply with the above conditions, and acknowledge and agree that Viral.net has the right, in
            its
            sole discretion, to terminate your account or take such other action as we see fit if you breach any of the
            above conditions or any of the other terms of these Terms of Use. This may include taking court action
            and/or
            reporting offending users to the relevant authorities.
            <br/>
            <br/>
            7. You Bear Risk of Upload. Viral.net uses reasonable security measures in order to attempt to protect any
            content or information that you upload (“Your Content”). However, Viral.net cannot guarantee that there will
            be
            no unauthorized copying or distribution of Your Content nor will Viral.net be liable for any copying or
            usage of
            Your Content not authorized by Viral.net. You hereby release and forever waive any claims you may have
            against
            Viral.net for any such unauthorized copying or usage of Your Content, under any theory of liability. THE
            SECURITY MEASURES TO PROTECT YOUR CONTENT USED BY VIRAL.NET HEREIN ARE PROVIDED AND USED "AS-IS" AND WITH NO
            WARRANTIES OR ASSURANCES THAT SUCH SECURITY MEASURES WILL WITHSTAND ATTEMPTS TO EVADE SECURITY MECHANISMS OR
            THAT THERE WILL BE NO CRACKS, DISABLEMENTS OR OTHER CIRCUMVENTION OF SUCH SECURITY MEASURES.
            <br/>
            <br/>
            8. Membership and Subscription; Pricing. You may become a free Member of the Service at no cost. As a free
            Member, you will have the ability to participate in some, but not all, of the features and services
            available
            within the Service. In order to access additional features and services, you must become a paying subscriber
            to
            the Service. Please note that the subscription policies that are disclosed to you in subscribing to the
            service
            are deemed part of this Terms of Use. Notwithstanding anything herein, you are solely responsible for all
            taxes
            associated with your use of the Websites and/or Service.
            <br/>
            <br/>
            <br/>
            <br/>
            9. Subscriptions; Charges on Your Account.
            a. General. Viral.net bills you through an online account (your "Billing Account") for use of the Service.
            You
            agree to pay Viral.net all charges at the prices then in effect for any use of the Service by you or other
            persons (including your agents) using your Billing Account, and you authorize Viral.net to charge your
            chosen
            payment provider (your "Payment Method") for the Service. You agree to make payment using that selected
            Payment
            Method. Viral.net reserves the right to correct any errors or mistakes that it makes even if it has already
            requested or received payment.
            b. Recurring Billing. Our subscription plans to the Service consist of an initial period, for which there is
            a
            one-time charge, followed by recurring period charges as agreed to by you. By entering into this Agreement,
            you
            acknowledge that your subscription has an initial and recurring payment feature and you accept
            responsibility
            for all recurring charges prior to cancellation. Viral.net may submit periodic charges (e.g. monthly)
            without
            further authorization from you, until you provide prior notice (confirmed in writing by Viral.net) that you
            have
            terminated this authorization or wish to change your payment method. Such notice will not affect charges
            submitted before Viral.net could reasonably act. To change or modify your payment method, visit the
            “Dashboard”
            page, then select “Credit Card” or “Bank Accounts,” then “Modify.” For your convenience, we take your
            payment
            information so that your Viral.net membership will not be interrupted. We auto-renew your membership at the
            level you selected. Your Viral.net subscription will be automatically extended for successive renewal
            periods of
            the same duration as the subscription term originally selected, at the then-current non-promotional
            subscription
            rate (if applicable). To cancel, visit the “Dashboard” page, then select “Subscription” and “Cancel.” You
            will
            not be eligible for a prorated refund of any portion of the subscription fee paid for the then-current
            subscription period.
            c. Current Information Required. YOU MUST PROVIDE CURRENT, COMPLETE AND ACCURATE INFORMATION FOR YOUR
            BILLING
            ACCOUNT. YOU MUST PROMPTLY UPDATE ALL INFORMATION TO KEEP YOUR BILLING ACCOUNT CURRENT, COMPLETE AND
            ACCURATE
            (SUCH AS A CHANGE IN BILLING ADDRESS, CREDIT CARD NUMBER, OR CREDIT CARD EXPIRATION DATE), AND YOU MUST
            PROMPTLY
            NOTIFY VIRAL.NET IF YOUR PAYMENT METHOD IS CANCELED (E.G., FOR LOSS OR THEFT) OR IF YOU BECOME AWARE OF A
            POTENTIAL BREACH OF SECURITY, SUCH AS THE UNAUTHORIZED DISCLOSURE OR USE OF YOUR USER NAME OR PASSWORD.
            CHANGES
            TO SUCH INFORMATION CAN BE MADE AT ACCOUNT SETTINGS. IF YOU FAIL TO PROVIDE VIRAL.NET ANY OF THE FOREGOING
            INFORMATION, YOU AGREE THAT VIRAL.NET MAY CONTINUE CHARGING YOU FOR ANY USE OF THE SERVICE UNDER YOUR
            BILLING
            ACCOUNT UNLESS YOU HAVE TERMINATED YOUR SUBSCRIPTION FOR THE SERVICE (CONFIRMED BY YOU IN WRITING UPON
            REQUEST
            BY VIRAL.NET).
            d. Payment Method. The terms of your payment will be based on your Payment Method and may be determined by
            agreements between you and the financial institution, credit card issuer or other provider of your chosen
            payment method.
            e. Reaffirmation of Authorization. Your non-termination or continued use of the Service reaffirms that
            Viral.net
            is authorized to charge your Payment Method. Viral.net may submit those charges for payment and you will be
            responsible for such charges. This does not waive Viral.net’s right to seek payment directly from you. Your
            charges may be payable in advance, in arrears, per usage, or as otherwise described when you initially
            subscribed to the Service.
            <br/>
            <br/>
            <br/>
            <br/>
            10. Modifications to Service. Viral.net reserves the right at any time to modify or discontinue, temporarily
            or
            permanently, the Service (or any part thereof) with or without notice. You agree that Viral.net shall not be
            liable to you or to any third party for any modification, suspension or discontinuance of the Service.
            <br/>
            <br/>
            11. Blocking of IP Addresses. In order to protect the integrity of the Services, Viral.net reserves the
            right at
            any time in its sole discretion to block Members from certain IP addresses from accessing the Websites
            and/or
            Service.
            <br/>
            <br/>
            12. Term. This Terms of Use will remain in full force and effect while you use the Websites and/or Service.
            You
            may terminate your membership at any time by visiting your Dashboard on Viral.net. If you resign or cancel
            your
            membership and/or subscription to Viral.net, to help Viral.net analyze and improve the Service, you may be
            asked
            to provide a reason for your resignation/cancellation. If Viral.net terminates your membership in the
            Service
            because you have breached this Agreement, you will not be entitled to any refund of unused subscription
            fees.
            <br/>
            <br/>
            Viral.net may terminate your membership and/or subscription for any reason by sending notice to you at the
            email
            address you provide in your application for membership, or such other email address as you may later provide
            to
            Viral.net. If Viral.net terminates your membership in the Service because you have breached this Terms of
            Use,
            you will not be entitled to any refund of unused subscription fees. All decisions regarding the termination
            of
            accounts shall be made in the sole discretion of Viral.net. Viral.net is not required to provide you notice
            prior to terminating your membership and/or subscription. Viral.net is not required, and may be prohibited,
            from
            disclosing a reason for the termination of your account. Even after your membership or subscription is
            terminated, this Terms of Use will remain in effect. All terms that by their nature may survive termination
            of
            this Terms of Use shall be deemed to survive such termination.
            13. Third Party Content. Viral.net may provide third party content on the Websites and/or Service and may
            provide links to webpages and content of third parties (collectively, the “Third-Party Content”) as a
            service to
            those interested in this information. Viral.net does not control, endorse or adopt any Third-Party Content
            and
            makes no representation or warranties of any kind regarding the Third-Party Content, including without
            limitation regarding its accuracy or completeness. Please be aware that Viral.net does not create
            Third-Party
            Content, nor does Viral.net update or monitor it. Viral.net is therefore not responsible for any Third-Party
            Content on the Service. Users use such Third-Party Content at their own risk.
            The Service may include links or references to other web sites or services solely as a convenience to
            Viral.net
            users (collectively, the “Reference Sites”). Viral.net does not endorse any Reference Sites or the
            information,
            materials, products, or services contained on or accessible through Reference Sites. In addition, your
            correspondence or business dealings with, or participation in promotions of, advertisers found on or through
            the
            Service are solely between you and the relevant advertiser. Access and use of Reference Sites, including the
            information, materials, products, and services on or available through Reference Sites is solely at your own
            risk.
            <br/>
            <br/>
            14. Intellectual Property. Viral.net, the Viral.net logos and any other product or service name or slogan
            contained in the Service are trademarks of Viral.net or our suppliers or licensors may not be copied,
            imitated
            or used, in whole or in part, without the prior written permission of Viral.net or the applicable trademark
            holder. Any authorized use of these trademarks must be in accordance with any guidelines that Viral.net may
            provide you from time to time.
            You may not use any metatags or any other hidden text utilizing " Viral.net" or any other name, trademark or
            product or service name of Viral.net without our prior written permission. In addition, the look and feel of
            the
            Viral.net Service, including all page headers, custom graphics, button icons and scripts, is the service
            mark,
            trademark and/or trade dress of Viral.net and may not be copied, imitated or used, in whole or in part,
            without
            our prior written permission. All other trademarks, registered trademarks, product names and company names
            or
            logos mentioned in the Service are the property of their respective owners. Reference to any products,
            services,
            processes or other information, by trade name, trademark, manufacturer, supplier or otherwise does not
            constitute or imply endorsement, sponsorship or recommendation thereof by us or any other affiliation.
            <br/>
            <br/>
            The Service is owned and operated by Viral.net. Unless otherwise indicated, all content and other materials
            on
            the Service, including, without limitation, Viral.net’s logos, the visual interfaces, graphics, design,
            compilation, information, software, computer code (including source code or object code), services, text,
            pictures, information, data, sound files, other files and the selection and arrangement thereof
            (collectively,
            the “Materials”) are protected by United States copyright, trade dress, patent, and trademark laws,
            international conventions, and all other relevant intellectual property and proprietary rights, and
            applicable
            laws (including in your country of residence).
            <br/>
            <br/>
            Viral.net reserves all rights not expressly granted in these Terms of Use.
            <br/>
            <br/>
            Unless otherwise expressly stated in writing by Viral.net, you are granted a limited, non-sublicensable
            license
            (i.e. a personal and limited right) to access and use the Service for your personal or internal business use
            only.
            <br/>
            <br/>
            This license is subject to these Terms of Use and does not include any of the following:
            <br/>
            <br/>
            a. any resale or commercial use of the Service or the Materials;
            b. the distribution, public performance or public display of any Materials;
            c. modifying or otherwise making any derivative uses of the Service or the Materials, or any portion of
            them;
            d. use of any data mining, robots or similar data gathering or extraction methods;
            e. downloading (except page caching) of any portion of the Service, the Materials or any information
            contained
            in them, except as expressly permitted on the Service; or
            f. any use of the Service or the Materials except for their intended purposes. Any use of the Service or the
            Materials except as specifically authorized in these Terms of Use, without the prior written permission of
            Viral.net, is strictly prohibited and your failure to comply with them may have legal consequences which may
            include violating applicable laws, including copyright and trademark laws and applicable communications
            regulations and statutes. Unless explicitly stated in these Terms of Use, nothing in them shall be
            interpreted
            as conferring any license to intellectual property rights, whether by estoppel, implication or other legal
            principles. This license can be terminated in accordance with these Terms of Use.
            15. Copyright Policy. Viral.net prohibits the submission or posting of any information that infringes or
            violates the copyright rights and/or other intellectual property rights (including rights of privacy and
            publicity) of any person or entity.
            Pursuant to Title 17, United States Code, Section 512(c)(2) or for any other claim of copyright
            infringement,
            you hereby agree that notifications of claimed copyright infringement be sent by certified mail to:
            <br/>
            <br/>
            Address: Viral, 105 W 29th St. 42L NY 10001 NY
            Phone number: 6466526662
            <br/>
            <br/>
            <br/>
            <br/>
            When contacting us, please make sure that you include the following information:
            a. a statement that you have identified Content on Viral.net that infringes your copyright or the copyright
            of a
            third party on whose behalf you are entitled to act;
            b. a description of the copyright work(s) that you claim have been infringed;
            c. a description of the Content that you claim is infringing and the Viral.net URL(s) where such Content can
            be
            located;
            d. your full name, address and telephone number, a valid email address on which you can be contacted, and
            your
            Viral.net user name if you have one;
            e. a statement by you that you have a good faith belief that the disputed use of the material is not
            authorized
            by the copyright owner, its agent, or the law; and
            f. a statement by you that the information in your notice is accurate and that you are authorized to act on
            behalf of the owner of the exclusive right that is allegedly infringed.
            <br/>
            <br/>
            In addition, if you wish for your notice to be considered as a notice pursuant to the United States Digital
            Millennium Copyright Act 17 U.S.C. ¤512(c), please also include the following:
            <br/>
            <br/>
            g. with respect to your statement that you are authorized to act on behalf of the owner of the exclusive
            right
            that is allegedly infringed, confirmation that such statement is made under penalty of perjury; and
            h. your electronic or physical signature (which may be a scanned copy).
            <br/>
            <br/>
            Viral.net will process any notice of alleged infringement which it receives and will take appropriate action
            as
            required by the Digital Millennium Copyright Act (DMCA) 17 U.S.C. 512(c)(3) or other applicable copyright
            law.
            U.S. law provides significant penalties for submitting such a statement falsely. Under appropriate
            circumstances, persons who repeatedly submit infringing or unlawful material will be prohibited from posting
            further submissions.
            <br/>
            <br/>
            The foregoing process applies to copyright only. If you discover any Content that you believe to be in
            violation
            of your trademark rights, please report this to us at Viral, 105 W 29th St. 42L NY 10001 NY or go@viral.net.
            In
            all other cases, if you discover Content that infringes any or violates any of your other rights, which you
            believe is defamatory, pornographic, obscene, racist or otherwise liable to cause widespread offence, or
            which
            constitutes impersonation, harassment, spam or otherwise violates these Terms of Use or applicable law,
            please
            report this to us at Viral, 105 W 29th St. 42L NY 10001 NY or go@viral.net.
            <br/>
            <br/>
            <br/>
            <br/>
            16. Repeat Infringer Policy. In accordance with the DMCA and other applicable laws around the world,
            Viral.net
            has adopted a policy that it will promptly terminate without notice any user's access to the Service if that
            user is determined by Viral.net to be a "repeat infringer." A repeat infringer includes, without limitation
            a
            user who has been notified by Viral.net of infringing activity violations more than twice and/or who has had
            any
            user-submitted content removed from the Service more than twice. Viral.net may also at our sole discretion
            limit
            access to the Service and/or terminate the accounts of any users who infringe any intellectual property
            rights
            of others, whether or not there is any repeat infringement.
            <br/>
            <br/>
            In addition, Viral.net accommodates and does not interfere with standard technical measures used by
            intellectual
            property rights owners to protect their materials.
            Please note that we do not offer refunds to Members whose accounts are terminated as a result of repeated
            infringement of these Terms of Use.
            17. Limitation of Liability. In no event shall Viral.net be liable for any damages whatsoever, whether
            direct,
            indirect, general, special, compensatory, consequential, and/or incidental, arising out of or relating to
            the
            Websites or Service, or use thereof. Nothing contained in the Websites or Service or in any written or oral
            communications from Viral.net or its employees or agents shall be construed to make any promise, covenant,
            warranty, or guaranty, all of which are explicitly disclaimed hereby, contrary to the statements and
            disclaimers
            contained in this paragraph.

            The content and functionality on the Websites and Service, along with the services provided by employees of
            the
            Websites and Service, are offered "as is" without warranty of any kind, either express or implied,
            including,
            without limitation, implied warranties of merchantability, fitness for a particular purpose, title and
            non-infringement. Viral.net makes no warranties, express or implied, as to the ownership, accuracy,
            completeness
            or adequacy of the Websites’ content or that the functionality of the Websites or Service will be
            uninterrupted
            or error-free or free from virus or third party attack. You hereby acknowledge that your use of the Websites
            and
            the Service is at your sole risk. UNDER NO CIRCUMSTANCES SHALL VIRAL.NET, ITS OFFICERS, OWNERS, EMPLOYEES OR
            AGENTS AND THEIR RESPECTIVE HEIRS, SUCCESSORS AND ASSIGNS BE LIABLE FOR ANY DAMAGES, INCLUDING DIRECT,
            INCIDENTAL, PUNITIVE, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES THAT DIRECTLY OR INDIRECTLY RESULT FROM
            USE
            OF, OR INABILITY TO USE, THE WEBSITES OR SERVICE OR THE INFORMATION CONTAINED THEREIN, INCLUDING WITHOUT
            LIMITATION FOR VIRUSES ALLEGED TO HAVE BEEN OBTAINED FROM THE WEBSITES OR SERVICE, EVEN IF VIRAL.NET HAS
            BEEN
            NOTIFIED OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES AND REGARDLESS OF THE THEORY OF LIABILITY.
            <br/>
            <br/>
            TO THE GREATEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO EVENT WILL VIRAL.NET HAVE ANY LIABILITY,
            CONTINGENT OR OTHERWISE, FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES IN ANY
            WAY
            ARISING OUT OF OR RELATING TO THE AGREEMENT, WEBSITES OR THE SERVICE, INCLUDING, BUT NOT LIMITED TO LOST
            PROFITS, LOST DATA, LOSS OF GOODWILL, COPYRIGHT INFRINGEMENT, WORK STOPPAGE, EQUIPMENT FAILURE OR
            MALFUNCTION,
            PERSONAL INJURY, PROPERTY DAMAGE, OR ANY OTHER DAMAGES OR LOSSES, EVEN IF VIRAL.NET HAS BEEN ADVISED OF THE
            POSSIBILITY THEREOF, AND REGARDLESS OF THE LEGAL OR EQUITABLE THEORY (CONTRACT, TORT, STATUTE, INDEMNITY OR
            OTHERWISE) UPON WHICH SUCH LIABILITY IS BASED.
            <br/>
            <br/>
            In the event that any of the foregoing limitations are deemed to be unenforceable, to the greatest extent
            permitted by law, you agree that the entire aggregate liability of Viral.net and sole remedy available to
            any
            Member in any case in any way arising out of or relating to the Agreement, Websites or the Service shall be
            limited to monetary damages that in the aggregate may not exceed the greater of $500.00 or the sum of any
            amount
            paid by the Member or user to Viral.net during the six months prior to notice to Viral.net of the dispute
            for
            which the remedy is sought.
            <br/>
            <br/>
            18. Indemnity by You. You agree to indemnify and hold Viral.net, its subsidiaries, affiliates, officers,
            agents,
            and other partners and employees, harmless from any loss, liability, claim, or demand, including reasonable
            attorneys' fees, arising out of or related to:
            <br/>
            <br/>
            a. your use of the Service and/or Websites in violation of this Terms of Use and/or arising from a breach of
            this Terms of Use including without limitation your representations and warranties set forth above;
            b. any third party claim of infringement of copyright or other intellectual property rights or invasion of
            privacy arising from the hosting of Your Content on the Websites, and/or your making available thereof to
            other
            users of the Websites, and/or the actual use of Your Content by other users of the Websites or related
            services
            in accordance with these Terms of Use and the parameters set by you with respect to the distribution and
            sharing
            of Your Content;
            c. any activity related to your account, be it by you or by any other person accessing your account with or
            without your consent unless such activity was caused by the act or default of Viral.net.
            <br/>
            <br/>
            19. Attorney Fees. In the event that Viral.net is successful in whole or in part in any action or proceeding
            related to or arising from this Terms of Use, you shall be responsible for Viral.net‘s attorneys' fees and
            costs.
            <br/>
            <br/>
            20. Parental or Guardian Permission. Some of the Content on the Websites may not be appropriate for
            children.
            CHILDREN UNDER THE AGE OF 18 ARE NOT PERMITTED TO USE THE WEBSITES AND/OR SERVICE UNLESS A SUPERVISING
            PARENT OR
            GUARDIAN IS PRESENT. INDIVIDUALS UNDER THE AGE OF 18 ARE NOT PERMITTED TO SUBSCRIBE TO OUR FEE-BASED
            SERVICES OR
            GIVE VIRAL.NET THEIR EMAIL ADDRESS OR ANY OTHER PERSONALLY IDENTIFIABLE INFORMATION.
            <br/>
            <br/>
            21. Privacy. Use of the Websites and/or the Service is also governed by our Privacy Policy, located at
            Viral.net/Privacy.
            <br/>
            <br/>
            22. Jurisdiction and Choice of Law; Dispute Resolution. If there is any dispute arising out of the Website
            and/or the Service, by using the Website and/or Service, you expressly agree that any such dispute shall be
            governed by the laws of the State of New York, without regard to its conflict of law provisions, and you
            expressly agree and consent to the exclusive jurisdiction and venue of the state and federal courts of the
            State
            of New York, for the resolution of any such dispute. Acceptance of the terms and conditions of this
            Agreement
            constitutes your consent to be sued in such courts and to accept service of process outside the State of New
            York with the same force and effect as if such service had been made within the State of New York. You
            hereby
            agree to accept service of process for any action hereunder by certified mail return receipt requested which
            service shall have the same force and effect as though service had been effected by personal service in the
            applicable jurisdiction. If any part of these terms is unlawful, void, or unenforceable, that part will be
            deemed severable and will not affect the validity and enforceability of the remaining provisions.
            <br/>
            <br/>
            23. Arbitration Provision/No Class Action. Except where prohibited by law, as a condition of using the
            Websites
            and/or Service, you agree that any and all disputes, claims and causes of action (collectively, "Claim")
            arising
            out of or connected with the Websites and/or Service, shall be resolved individually, without resort to any
            form
            of class action, exclusively by binding arbitration for full and final settlement of such Claim, and
            judgment on
            the award rendered in the arbitration may be entered in any court having jurisdiction thereof. The parties
            shall
            split the arbitration and/or mediator costs. An award rendered by the arbitrator(s) may be entered and
            confirmed
            by the courts of the State of New York, County of New York, or the United States District Court for the
            Southern
            District of New York. The parties agree that any post-arbitration action seeking to enforce an arbitration
            award
            or action seeking equitable or injunctive relief shall be brought exclusively in the courts of the State of
            New
            York, County of New York, or the United States District Court for the Southern District of New York.
            <br/>
            <br/>
            24. No Third Party Beneficiaries. You agree that, except as otherwise expressly provided in this Terms of
            Use,
            there shall be no third party beneficiaries to this Terms of Use.
            <br/>
            <br/>
            25. Availability Outside the U.S. If you access Viral.net from outside of the United States, you do so at
            your
            own risk and are responsible for compliance with the laws of your jurisdiction. If you access the Websites
            or
            Service from outside of the United States, you acknowledge that any personal information you provide will be
            processed in the United States and other geographies as selected by us in our sole discretion, and you
            hereby
            consent to the collection and processing of your personal information in a manner consistent with this
            Agreement
            and the Privacy Policy.
            <br/>
            <br/>
            26. Entire Agreement.
            <br/>
            <br/>
            This Terms of Use, along with the Privacy Policy, contains the entire agreement between you and Viral.net
            regarding the use of the Websites and/or the Service.
            <br/>
            <br/>
            27. Severability; Waiver. If any provision of this Terms of Use is found to be invalid by any court having
            competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining
            provisions of this Terms of Use, which shall remain in full force and effect. No waiver of any term of this
            Terms of Use shall be deemed a further or continuing waiver of such term or any other term. In addition,
            Viral.net’s failure to enforce any term of this Terms of Use shall not be deemed as a waiver of such term or
            otherwise affect Viral.net’s ability to enforce such term at any point in the future.
            <br/>
            <br/>
            28. Headings. The section headings contained in this Terms of Use are for reference purposes only and shall
            not
            in any way affect the meaning or interpretation of this Terms of Use.
            Please contact us with any questions regarding this agreement. Viral.net is a trademark of Viral (Viral,
            Inc.)
            <br/>
            <br/>
            I HAVE READ THIS AGREEMENT AND AGREE TO ALL OF THE PROVISIONS CONTAINED ABOVE.
        </p>
    </div>
);

export default TermsOfUse;


// WEBPACK FOOTER //
// ./src/components/info/terms-of-use/TermsOfUse.js